import {useMemo} from 'react'

const useDatePickerScrollProps = (id: string) => {
    const scrollProps = useMemo(() => {
        return {
            props: {
                onOpenChange: (isOpen: boolean) => {
                    if (isOpen) {
                        setTimeout(() => {
                            const item = document.querySelector(`[data-name=${id}]`)
                            item.querySelector('.ant-picker-dropdown').scrollIntoView({
                                block: 'nearest',
                                behavior: 'smooth',
                            })
                        }, 4)
                    }
                },
                getPopupContainer: (trigger: HTMLElement): HTMLElement => trigger.parentElement,
            },
            itemProps: {
                'data-name': id,
            },
        }
    }, [])

    return scrollProps
}

export default useDatePickerScrollProps
